

import './style.css';

export default function AboutSection(){
    return(
        <section id="About">
            <div className="page center">
                <div className="sub-section">
                    <div className="header-div">
                        <h1 className="title">My Expertise</h1>
                    </div>
                    <p className="description">
                    🚀 Optimized backend systems achieving 90%+ performance improvements.<br/>
⚡ Strong expertise in Golang concurrency (goroutines, channels).
🧠 Experience designing event-driven architectures using Kafka & Redis. <br/>
🏗️ Focus on clean architecture & production-ready systems.
🔐 Built secure systems (IAM/PAM) with real-world security practices. <br/>
📈 Proven ability to debug, scale, and improve high-traffic systems.
                    </p>
                    <div className="tab">
                        <div className="tab-item">
                            <h1 className="number">3+</h1>
                            <p className="description">Years of <br/>Exaperience</p>
                        </div>
                        <div className="tab-item">
                            <h1 className="number">7+</h1>
                            <p className="description">Total <br/>Projects</p>
                        </div>
                    </div>
                    <div className="skills">
                        <div className="group-box">
                            <div className="group">
                                <label>LANGUAGE</label>
                                <p className="tags"><span>Golang</span><span>Java</span><span>C</span><span>Javascript</span><span>PHP</span><span>SQL</span></p>
                            </div>
                            <div className="group">
                                <label>CLOUD & DEVOPS</label>
                                <p className="tags"><span>Docker</span><span>Kubernetes</span><span>AWS Services</span><span>Nginx</span><span>Git</span><span>Load Balancing</span><span>Auto Scaling</span><span>API Gateway</span></p>
                            </div>
                        </div>
                        <div>
                            <div className="group-box">
                                <div className="group">
                                    <label>ADDITIONAL SKILLS</label>
                                    <p className="tags"><span>RESTful APIs</span><span>gRPC</span><span>Microservices Architecture</span><span>Database Optimization</span><span>Distributed systems</span><span>Agile</span><span>API security (rate limiting, OAuth2, JWT)</span><span>Docker</span><span>Problem Solving</span></p>
                                </div>
                                <div className="group">
                                    <label>FRAMEWORKS & LIBRARIES</label>
                                    <p className="tags"><span>Gin</span><span>GORM</span><span>React.JS</span><span>Chrome Extensions</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="sub-section stack-div">
                    <ul className="stack">
                        {
                            stack.map((items,index)=>(
                                <StackItem key={index} Img={items.Img} Name={items.Name} Icon={items.Icon}/>
                            ))
                        }
                    </ul>
                </div> */}
            </div>
        </section>
    );
}